import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://fshgilyoeqiulfzcyxan.supabase.co';
const supabaseAnonKey = 'sb_publishable_DGXt5Ji7_TdI94D35xyLag__DdxRfeI';

console.log('Supabase init - URL exists:', !!supabaseUrl, 'Key exists:', !!supabaseAnonKey, 'Key starts:', supabaseAnonKey?.substring(0, 20));

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
  },
});